export default defineNuxtRouteMiddleware(async (to) => {
  if (to.path.startsWith('/api/')) return

  const store = useAuthStore()

  // Toujours tenter fetchSession si pas encore authentifié
  if (!store.authenticated) {
    await store.fetchSession()
  }

  if (store.loggingOut) return abortNavigation()

  if (!store.authenticated) {
    let state = to.path
    if (state.startsWith('/api/') || state.includes('callback')) {
      state = '/'
    }

    if (import.meta.client) {
      window.location.href = `/api/auth/login?state=${encodeURIComponent(state)}`
      // Promesse jamais résolue plutôt qu'abortNavigation() : en ssr: false, Nuxt
      // transforme tout middleware renvoyant false pendant l'hydratation initiale
      // en 404. La navigation reste suspendue le temps que le navigateur parte.
      return new Promise<void>(() => {})
    }

    return navigateTo(`/api/auth/login?state=${encodeURIComponent(state)}`, { external: true })
  }

  /*
   * Connecté au SSO, mais sans accès à cette application (#190) : une seule
   * page lui est ouverte, celle qui le lui dit. La garde vit aussi côté
   * serveur, où toutes les routes d'administration le refusent.
   */
  if (store.user?.sansAcces) {
    if (to.path !== '/acces-refuse') return navigateTo('/acces-refuse')
    return
  }

  // La page de blocage n'a rien à montrer à qui a accès.
  if (to.path === '/acces-refuse') return navigateTo('/')
})
